<template>
  <div class="activity">
    <!-- <div class="banner">
      <img src="../../assets/banner.png" alt="">
    </div>
  -->
    <div class="activity_content container">
      <div class="video_type">
        <div class="train_title">
          <span class="iconfont iconleixing"></span>活动列表
        </div>
        <!-- <div class="type_list">
          <div :class="['type_item', { type_item_active: item.id == itemidflag }]" v-for="item in typeList" :key="item.id" @click="typeclick(item.id)">
              {{ item.typeName }}
          </div>
        </div> -->
      </div>
      <div class="activity_list">
        <!-- <el-row :gutter="20">
           <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-for="item in activityList" :key="item.id">
            <div class="list_item" @click="activityDetail(item.id)">
              <div class="item_left">
                <img src="../../assets/activity.png" alt="">
              </div>
              <div class="item_right">
                <div class="item_right_title e-line-1">
                  {{ item.activityName }}
                </div>
                <div class="item_right_content e-line-2">
                  {{ item.activityJianjie }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
           <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-for="item in activityList" :key="item.id">
            <div class="list_item" @click="activityDetail(item.id)">
              <div class="item_left">
                <img src="../../assets/activity.png" alt="">
              </div>
              <div class="item_right">
                <div class="item_right_title e-line-1">
                  {{ item.title }}
                </div>
                <div class="item_right_content e-line-2">
                  {{ item.depict }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row> 
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="dataform.page"
          @current-change="handleCurrentChange"
          @prev-click="getActivityList"
          @next-click="getActivityList"
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activity',
  data () {
    return {
      dataform: {
        page: 1,
        limit: 10,
        // typeId: ''
        status:2
      },
      typeList: [],
      total: 0,
      activityList: '',
      itemidflag: ''
    }
  },
  mounted () {
    let id = this.$route.query.id
    if(id != undefined) {
      this.dataform.type = id
      this.itemidflag = id
    }
    this.gettype()
    this.getActivityList()
  },
  methods: {
    async gettype() {
      let {
        data: { data, code },
      } = await this.$http.get("api/publishtype/selectAll");
      if (code != 0) return;
      this.typeList = data;
    },
    activityDetail(id) {
      this.$router.push({ path: '/noticeDetail', query: { id }})
    },
    handleCurrentChange(v) {
      this.dataform.page = v
      this.getActivityList()
    },
    async getActivityList() {
      let { data: { code, data }} = await this.$http.get('/api/information/page', { params: this.dataform})
      if(code != 0) return
      this.activityList = data.list
      this.total = data.total
    },
    typeclick(i) {
      if(i == this.itemidflag) {
        this.itemidflag = ''
        this.dataform.typeId = ''
      } else {
        this.itemidflag = i
        this.dataform.typeId = i
      }    
      this.dataform.page = 1
      this.getActivityList()
    },
  }
}
</script>

<style lang="scss" scoped>
.activity {
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
    .video_type {
      .train_title {
        font-size: 24px;
        line-height: 2;
        .iconleixing {
          font-size: 28px;
          color: #3498db;
          margin-right: 5px;
        }
      }
      .type_list {
        .type_item {
          cursor: pointer;
          display: inline-block;
          border: 2px solid rgba($color: #3498db, $alpha: 1);
          padding: 5px 15px;
          margin: 5px;
          background: rgba($color: #2980b9, $alpha: 1);
          color: #fff;
        }
        .type_item_active {
          border: 2px solid rgba($color: #de010e, $alpha: .6);
          background-color: #de010e;
          color: #fff;
        }    
      }    
    }
  .activity_content {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    .activity_title {
      font-size: 24px;
      line-height: 2;
      .iconliebiao {
        font-size: 28px;
        color: #3498db;
        margin-right: 5px;
      }
    }
    .activity_list { 
      padding-top: 10px;
      .list_item {
        position: relative;
        top: 0;
        cursor: pointer;
        display: flex;
        margin: 10px 0;
        border: 2px solid #E4E7ED;
        padding: 10px;
        border-radius: 7px;
        transition: .2s ease-out;
        height: 85px;
       &:hover {
          box-shadow: 2px 2px 2px #C0C4CC;
          top: -3px
        }
        .item_left {
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 50px;
            height: 50px;
            object-fit: contain;
          }
        }
        .item_right {
          line-height: 1.5;
          .item_right_title {
            line-height: 2;
            font-size: 18px;
            font-weight: 700;
            color: #303133;
          }
          .item_right_content {
            font-size: 16px;
            color: #606266;
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0 30px 0;
    }
  }
  
}
</style>